import ableton from "./ableton.svg?raw";
import addToStack from "./add-to-stack.svg?raw";
import aiSparkles from "./ai-sparkles.svg?raw";
import aiSparklesSolid from "./ai-sparkles-solid.svg?raw";
import alert from "./alert.svg?raw";
import alertSolid from "./alert-solid.svg?raw";
import allDownloads from "./all-downloads.svg?raw";
import allDownloadsSolid from "./all-downloads-solid.svg?raw";
import apple from "./apple.svg?raw";
import arrowDown from "./arrow-down.svg?raw";
import arrowLeft from "./arrow-left.svg?raw";
import arrowLeftTerminal from "./arrow-left-terminal.svg?raw";
import arrowRight from "./arrow-right.svg?raw";
import arrowRightTerminal from "./arrow-right-terminal.svg?raw";
import arrowUp from "./arrow-up.svg?raw";
import arrowUpRight from "./arrow-up-right.svg?raw";
import astraLogo from "./astra-logo.svg?raw";
import ban from "./ban.svg?raw";
import beatmakerLogo from "./beatmaker-logo.svg?raw";
import cc from "./cc.svg?raw";
import ccAmex from "./cc-amex.svg?raw";
import ccDiscover from "./cc-discover.svg?raw";
import ccMastercard from "./cc-mastercard.svg?raw";
import ccVisa from "./cc-visa.svg?raw";
import check from "./check.svg?raw";
import checkCircle from "./check-circle.svg?raw";
import checkCircleEmpty from "./check-circle-empty.svg?raw";
import checkCircleSolid from "./check-circle-solid.svg?raw";
import chevronCircleDown from "./chevron-circle-down.svg?raw";
import chevronCircleLeft from "./chevron-circle-left.svg?raw";
import chevronCircleRight from "./chevron-circle-right.svg?raw";
import chevronCircleUp from "./chevron-circle-up.svg?raw";
import chevronDown from "./chevron-down.svg?raw";
import chevronLeft from "./chevron-left.svg?raw";
import chevronRight from "./chevron-right.svg?raw";
import chevronUp from "./chevron-up.svg?raw";
import clock from "./clock.svg?raw";
import collection from "./collection.svg?raw";
import comment from "./comment.svg?raw";
import computer from "./computer.svg?raw";
import copy from "./copy.svg?raw";
import copyModified from "./copy-modified.svg?raw";
import copyright from "./copyright.svg?raw";
import discord from "./discord.svg?raw";
import download from "./download.svg?raw";
import ellipsis from "./ellipsis.svg?raw";
import ellipsisHorizontal from "./ellipsis-horizontal.svg?raw";
import enter from "./enter.svg?raw";
import externalLink from "./external-link.svg?raw";
import facebook from "./facebook.svg?raw";
import file from "./file.svg?raw";
import fileDownload from "./file-download.svg?raw";
import filter from "./filter.svg?raw";
import flStudio from "./fl-studio.svg?raw";
import flag from "./flag.svg?raw";
import flat from "./flat.svg?raw";
import folder from "./folder.svg?raw";
import folderSolid from "./folder-solid.svg?raw";
import garageband from "./garageband.svg?raw";
import genre from "./genre.svg?raw";
import hamburger from "./hamburger.svg?raw";
import heart from "./heart.svg?raw";
import home from "./home.svg?raw";
import heartSolid from "./heart-solid.svg?raw";
import infoCircleSolid from "./info-circle-solid.svg?raw";
import instagram from "./instagram.svg?raw";
import instrument from "./instrument.svg?raw";
import keyboard from "./keyboard.svg?raw";
import lightbulb from "./lightbulb.svg?raw";
import link from "./link.svg?raw";
import loading from "./loading.svg?raw";
import lock from "./lock.svg?raw";
import logicPro from "./logic-pro.svg?raw";
import loop from "./loop.svg?raw";
import maximize from "./maximize.svg?raw";
import messages from "./messages.svg?raw";
import midi from "./midi.svg?raw";
import minimize from "./minimize.svg?raw";
import minus from "./minus.svg?raw";
import moon from "./moon.svg?raw";
import noteEighth from "./note-eighth.svg?raw";
import noteHalf from "./note-half.svg?raw";
import noteQuarter from "./note-quarter.svg?raw";
import noteSixteenth from "./note-sixteenth.svg?raw";
import noteWhole from "./note-whole.svg?raw";
import offline from "./offline.svg?raw";
import oneshot from "./oneshot.svg?raw";
import packs from "./packs.svg?raw";
import pause from "./pause.svg?raw";
import pauseCircle from "./pause-circle.svg?raw";
import pencil from "./pencil.svg?raw";
import people from "./people.svg?raw";
import person from "./person.svg?raw";
import personSolid from "./person-solid.svg?raw";
import pin from "./pin.svg?raw";
import play from "./play.svg?raw";
import playCircle from "./play-circle.svg?raw";
import playSolid from "./play-solid.svg?raw";
import plus from "./plus.svg?raw";
import plusCircle from "./plus-circle.svg?raw";
import preset from "./preset.svg?raw";
import question from "./question.svg?raw";
import refresh from "./refresh.svg?raw";
import search from "./search.svg?raw";
import searchSolid from "./search-solid.svg?raw";
import searchSparkles from "./search-sparkles.svg?raw";
import select from "./select.svg?raw";
import settings from "./settings.svg?raw";
import share from "./share.svg?raw";
import sharp from "./sharp.svg?raw";
import shuffle from "./shuffle.svg?raw";
import siso from "./siso.svg?raw";
import skillsLogo from "./skills-logo.svg?raw";
import skipNext from "./skip-next.svg?raw";
import skipPrevious from "./skip-previous.svg?raw";
import soundsLogo from "./sounds-logo.svg?raw";
import spliceBridge from "./splice-bridge.svg?raw";
import spliceLogo from "./splice-logo.svg?raw";
import stack from "./stack.svg?raw";
import star from "./star.svg?raw";
import starHalfSolid from "./star-half-solid.svg?raw";
import starSolid from "./star-solid.svg?raw";
import stop from "./stop.svg?raw";
import stopSolid from "./stop-solid.svg?raw";
import studioLogo from "./studio-logo.svg?raw";
import studioOne from "./studio-one.svg?raw";
import sun from "./sun.svg?raw";
import thumbsDown from "./thumbs-down.svg?raw";
import thumbsDownSolid from "./thumbs-down-solid.svg?raw";
import thumbsUp from "./thumbs-up.svg?raw";
import thumbsUpSolid from "./thumbs-up-solid.svg?raw";
import tiktok from "./tiktok.svg?raw";
import trash from "./trash.svg?raw";
import twitter from "./twitter.svg?raw";
import undo from "./undo.svg?raw";
import unlock from "./unlock.svg?raw";
import upgradeCircle from "./upgrade-circle.svg?raw";
import upgradeCircleSolid from "./upgrade-circle-solid.svg?raw";
import userAudio from "./user-audio.svg?raw";
import video from "./video.svg?raw";
import videoSolid from "./video-solid.svg?raw";
import volumeDown from "./volume-down.svg?raw";
import volumeMute from "./volume-mute.svg?raw";
import volumeUp from "./volume-up.svg?raw";
import warning from "./warning.svg?raw";
import warningSolid from "./warning-solid.svg?raw";
import webCredit from "./web-credit.svg?raw";
import windows from "./windows.svg?raw";
import x from "./x.svg?raw";
import xCircle from "./x-circle.svg?raw";
import xCircleSolid from "./x-circle-solid.svg?raw";
import youtube from "./youtube.svg?raw";

export const icons = {
    ableton,
    addToStack,
    aiSparkles,
    aiSparklesSolid,
    alert,
    alertSolid,
    allDownloads,
    allDownloadsSolid,
    apple,
    arrowDown,
    arrowLeft,
    arrowLeftTerminal,
    arrowRight,
    arrowRightTerminal,
    arrowUp,
    arrowUpRight,
    astraLogo,
    ban,
    beatmakerLogo,
    cc,
    ccAmex,
    ccDiscover,
    ccMastercard,
    ccVisa,
    check,
    checkCircle,
    checkCircleEmpty,
    checkCircleSolid,
    chevronCircleDown,
    chevronCircleLeft,
    chevronCircleRight,
    chevronCircleUp,
    chevronDown,
    chevronLeft,
    chevronRight,
    chevronUp,
    clock,
    collection,
    comment,
    computer,
    copy,
    copyModified,
    copyright,
    discord,
    download,
    ellipsis,
    ellipsisHorizontal,
    enter,
    externalLink,
    facebook,
    file,
    fileDownload,
    filter,
    flStudio,
    flag,
    flat,
    folder,
    folderSolid,
    garageband,
    genre,
    hamburger,
    heart,
    heartSolid,
    home,
    infoCircleSolid,
    instagram,
    instrument,
    keyboard,
    lightbulb,
    link,
    loading,
    lock,
    logicPro,
    loop,
    maximize,
    messages,
    midi,
    minimize,
    minus,
    moon,
    noteEighth,
    noteHalf,
    noteQuarter,
    noteSixteenth,
    noteWhole,
    offline,
    oneshot,
    packs,
    pause,
    pauseCircle,
    pencil,
    people,
    person,
    personSolid,
    pin,
    play,
    playCircle,
    playSolid,
    plus,
    plusCircle,
    preset,
    question,
    refresh,
    search,
    searchSolid,
    searchSparkles,
    select,
    settings,
    share,
    sharp,
    shuffle,
    siso,
    skillsLogo,
    skipNext,
    skipPrevious,
    soundsLogo,
    spliceBridge,
    spliceLogo,
    stack,
    star,
    starHalfSolid,
    starSolid,
    stop,
    stopSolid,
    studioLogo,
    studioOne,
    sun,
    thumbsDown,
    thumbsDownSolid,
    thumbsUp,
    thumbsUpSolid,
    tiktok,
    trash,
    twitter,
    undo,
    unlock,
    upgradeCircle,
    upgradeCircleSolid,
    userAudio,
    video,
    videoSolid,
    volumeDown,
    volumeMute,
    volumeUp,
    warning,
    warningSolid,
    webCredit,
    windows,
    x,
    xCircle,
    xCircleSolid,
    youtube,
} as const;

export type IconName = keyof typeof icons;

export const kIconSize_px = 24;

export const createSvgIcon = (
    iconName: IconName,
    className?: string,
    init?: (el: SVGSVGElement) => void,
): SVGSVGElement => {
    const wrapper = document.createElement("span");
    wrapper.innerHTML = icons[iconName];
    const svg = wrapper.firstElementChild as SVGSVGElement;
    if (className !== undefined) {
        svg.setAttribute("class", className);
    }
    svg.removeAttribute("fill");
    for (const el of svg.querySelectorAll("[fill]")) {
        el.setAttribute("fill", "currentColor");
    }
    for (const el of svg.querySelectorAll("[stroke]")) {
        el.setAttribute("stroke", "currentColor");
    }
    init?.(svg);
    return svg;
};
